import React, { useContext, useEffect, useRef, useState } from "react";
import { TableCell, TableRow, TableHead, IconButton, Button, Typography } from "@material-ui/core";
import MUIDataTable, { TableHead as MuiTableHead } from "mui-datatables";
import { makeStyles } from "@material-ui/core/styles";
import { GblContext } from "providers/formatter";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CustomToolbar from "./CustomToolbar";
import { FaAngleDoubleDown, FaAngleDoubleRight } from "react-icons/fa";
import ReportBackDrop from "components/ReportBackDrop";
import { showReportByName } from "pages/Report/services";

const useStyles = makeStyles(() => ({
  btnColorCell: {
    backgroundColor: "#fff",
    color: "#000",
    "&:hover, &:focus": {
      backgroundColor: "#fff",
      color: "#000",
    },
    textTransform: "none",
  },
  colorCell: {
    backgroundColor: "#34558b",
    color: "#fff",
    position: "sticky",
    top: 0,
  },
  cellHeaderName: {
    fontWeight: "bold",
    paddingTop: 8,
    paddingBottom: 8,
  },
  cellHeaderNumber: {
    fontWeight: "bold",
    paddingTop: 8,
    paddingBottom: 8,
    borderBottom: "1px solid black",
  },
  cellHeader: {
    backgroundColor: "#B8CCE4",
    fontWeight: "bold",
    borderBottom: "1px solid black",
  },
  TableRow: {
    cursor: "pointer",
    paddingLeft: 0,
  },
  TableRowSub: {
    cursor: "default",
    paddingLeft: 0,
  },
  IconWrapper: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.10)",
      borderRadius: "50%",
    },
  },
}));

const Table = ({ basePath, dataTable, title, permissions, parameters, showReportLoader, hideReportLoader }) => {
  const { NumberFormat } = useContext(GblContext);
  const classes = useStyles();

  const [open, setOpen] = useState({});
  const [statusOpen, setStatusOpen] = useState(false);
  const toggleRow = (name) => {
    const newRowState = { ...open };
    newRowState[name] = !newRowState[name];
    setOpen(newRowState);
  };

  const expandAll = () => {
    setStatusOpen(true);
    const openSub = [];
    dataTable.map((el, i) => {
      if (el.children?.length > 0) {
        el.children.forEach((jItem) => {
          openSub.push({
            [`${jItem.Name}`]: true,
          });
          if (jItem.children?.length > 0) {
            jItem.children.forEach((kItem) => {
              openSub.push({
                [`${kItem.Name}`]: true,
              });
              if (kItem.children?.length > 0) {
                kItem.children.forEach((lItem) => {
                  openSub.push({
                    [`${lItem.Name}`]: true,
                  });
                  if (lItem.children?.length > 0) {
                    lItem.children.forEach((mItem) => {
                      openSub.push({
                        [`${mItem.Name}`]: true,
                      });
                    });
                  }
                });
              }
            });
          }
        });
      }
      return el;
    });
    const result = openSub.reduce((acc, curr) => {
      return { ...acc, ...curr };
    }, {});
    setOpen(result);
  };

  const collapseAll = () => {
    setStatusOpen(false);
    const openSub = [];
    dataTable.map((el, i) => {
      if (el.children?.length > 0) {
        el.children.forEach((jItem) => {
          openSub.push({
            [`${jItem.Name}`]: true,
          });
          if (jItem.children?.length > 0) {
            jItem.children.forEach((kItem) => {
              if (kItem.children?.length > 0 && kItem.Percent === null) {
                openSub.push({
                  [`${kItem.Name}`]: true,
                });
              } else {
                openSub.push({
                  [`${kItem.Name}`]: false,
                });
              }
              // if (kItem.children?.length > 0) {
              //   kItem.children.forEach((lItem) => {
              //     openSub.push({
              //       [`${lItem.Name}`]: true,
              //     });
              //   });
              // }
            });
          }
        });
      }
      return el;
    });
    const result = openSub.reduce((acc, curr) => {
      return { ...acc, ...curr };
    }, {});
    setOpen(result);
  };

  let shouldGet = useRef(true);
  useEffect(() => {
    if (shouldGet.current) {
      shouldGet.current = false;
      const openSub = [];
      if (dataTable) {
        dataTable.map((el, i) => {
          if (el.children?.length > 0) {
            el.children.forEach((jItem) => {
              if (jItem.children?.length > 0 && jItem.Percent === null) {
                openSub.push({
                  [`${jItem.Name}`]: true,
                });
              }
              if (jItem.children?.length > 0) {
                jItem.children.forEach((kItem) => {
                  if (kItem.children?.length > 0 && kItem.Percent === null) {
                    openSub.push({
                      [`${kItem.Name}`]: true,
                    });
                  } else {
                    openSub.push({
                      [`${kItem.Name}`]: false,
                    });
                  }
                  if (kItem.children?.length > 0) {
                    kItem.children.forEach((lItem) => {
                      openSub.push({
                        [`${lItem.Name}`]: false,
                      });
                    });
                  }
                });
              }
            });
          }
          return el;
        });

        const result = openSub.reduce((acc, curr) => {
          return { ...acc, ...curr };
        }, {});
        setOpen(result);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const findTotal = (data) => {
    let dTotal = data.Name.slice(0, 5) === "Total";
    if (dTotal) {
      return true;
    } else {
      return false;
    }
  };

  const columns = [
    {
      name: "Name",
      label: "Name",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: (value, data) => {
          return <b style={{ marginLeft: -20 }}>{value}</b>;
        },
      },
    },
    {
      name: "Current",
      label: "Current Month",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: () => {
          return null;
        },
      },
    },
    {
      name: "Prior",
      label: "Prior Month",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: () => {
          return null;
        },
      },
    },
    {
      name: "Varience",
      label: "Variance",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: () => {
          return null;
        },
      },
    },
    {
      name: "Percent",
      label: "%",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: () => {
          return null;
        },
      },
    },
  ];

  const printReport = async (viewBy) => {
    showReportLoader();
    await showReportByName("GL_FIN_BS_MONTH", [
      { Name: "YearNo", Value: parameters.Year },
      { Name: "PeriodNo", Value: parameters.Period },
      { Name: "Departments", Value: parameters.Departments.join() },
      { Name: "ViewBy", Value: viewBy },
    ]);
    setTimeout(() => {
      hideReportLoader();
    }, 2000);
  };

  const options = {
    selectableRows: "none",
    filter: false,
    filterType: "dropdown",
    responsive: "standard",
    download: false,
    print: false,
    search: false,
    viewColumns: false,
    filters: false,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    pagination: false,
    customToolbar: () => {
      return (
        <CustomToolbar
          basePath={basePath}
          id={"BS"}
          dataTable={dataTable}
          permissions={permissions}
          printReport={printReport}
        />
      );
    },
    setTableProps: () => ({
      size: "small",
    }),
    isRowExpandable: (dataIndex, expandedRows) => {
      if (dataTable[dataIndex]?.hasOwnProperty("children") === false) {
        return false;
      }

      return true;
    },
    rowsExpanded: dataTable && dataTable?.map((el, i) => i),
    renderExpandableRow: (rowData, rowMeta) => {
      const rowIndex = rowMeta.rowIndex;
      const subChild = dataTable[rowIndex].children;

      if (subChild && Array.isArray(subChild) && subChild.length > 0) {
        return subChild?.map((subItem, index) => (
          <React.Fragment key={`sub${index}`}>
            <TableRow onClick={() => toggleRow(subItem.Name)}>
              <TableCell style={{ paddingLeft: 25 }}>
                {subItem.children && (
                  <IconButton onClick={() => toggleRow(subItem.Name)} size="small">
                    {open[subItem.Name] ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                  </IconButton>
                )}
              </TableCell>
              {subItem.IsBold ? (
                <TableCell className={classes.cellHeaderName}>
                  {subItem.children ? (
                    <strong>{subItem.Name}</strong>
                  ) : (
                    <strong style={{ marginLeft: -20 }}>{subItem.Name}</strong>
                  )}
                </TableCell>
              ) : (
                <TableCell>{subItem.Name}</TableCell>
              )}

              <TableCell align="right" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.Current === null ? null : NumberFormat(subItem.Current ?? 0)}
              </TableCell>
              <TableCell align="right" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.Prior === null ? null : NumberFormat(subItem.Prior ?? 0)}
              </TableCell>
              <TableCell align="right" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.Varience === null ? null : NumberFormat(subItem.Varience ?? 0)}
              </TableCell>
              <TableCell align="right" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.Percent === null ? null : NumberFormat(subItem.Percent ?? 0)}
              </TableCell>
            </TableRow>

            {open[subItem.Name] &&
              subItem.children &&
              subItem.children.map((item, childIndex) => (
                <>
                  <TableRow
                    key={`child${childIndex}`}
                    className={classes.TableRowSub}
                    onClick={() => toggleRow(item.Name)}
                  >
                    <TableCell style={{ paddingLeft: 40 }}>
                      {item.children && (
                        <IconButton onClick={() => toggleRow(item.Name)} size="small">
                          {open[item.Name] ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell
                      style={{ paddingLeft: findTotal(item) ? 15 : 30 }}
                      className={findTotal(item) ? classes.cellHeaderName : ""}
                    >
                      {item.Name}
                    </TableCell>
                    <TableCell align="right" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.Current === null ? null : NumberFormat(item.Current ?? 0)}
                    </TableCell>
                    <TableCell align="right" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.Prior === null ? null : NumberFormat(item.Prior ?? 0)}
                    </TableCell>
                    <TableCell align="right" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.Varience === null ? null : NumberFormat(item.Varience ?? 0)}
                    </TableCell>
                    <TableCell align="right" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.Percent === null ? null : NumberFormat(item.Percent ?? 0)}
                    </TableCell>
                  </TableRow>

                  {open[item.Name] &&
                    item.children &&
                    item.children.map((subChild, subChildIndex) => (
                      <>
                        <TableRow
                          key={`subChild${subChildIndex}`}
                          className={classes.TableRowSub}
                          onClick={() => toggleRow(subChild.Name)}
                        >
                          <TableCell style={{ paddingLeft: 60 }}>
                            {subChild.children && (
                              <IconButton onClick={() => toggleRow(subChild.Name)} size="small">
                                {open[subChild.Name] ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                              </IconButton>
                            )}
                          </TableCell>
                          <TableCell
                            style={{ paddingLeft: findTotal(subChild) ? 30 : 45 }}
                            className={findTotal(subChild) ? classes.cellHeaderName : ""}
                          >
                            {subChild.Name}
                          </TableCell>
                          <TableCell align="right" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {NumberFormat(subChild.Current ?? 0)}
                          </TableCell>
                          <TableCell align="right" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {NumberFormat(subChild.Prior ?? 0)}
                          </TableCell>
                          <TableCell align="right" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {NumberFormat(subChild.Varience ?? 0)}
                          </TableCell>
                          <TableCell align="right" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {NumberFormat(subChild.Percent ?? 0)}
                          </TableCell>
                        </TableRow>

                        {open[subChild.Name] &&
                          subChild.children &&
                          subChild.children.map((subLastChild, subLastChildIndex) => (
                            <>
                              <TableRow
                                key={`subLastChild${subLastChildIndex}`}
                                className={classes.TableRowSub}
                                onClick={() => toggleRow(subLastChild.Name)}
                              >
                                <TableCell style={{ paddingLeft: 60 }}>
                                  {subLastChild.children && (
                                    <IconButton onClick={() => toggleRow(subLastChild.Name)} size="small">
                                      {open[subLastChild.Name] ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                                    </IconButton>
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{ paddingLeft: findTotal(subLastChild) ? 30 : 60 }}
                                  className={findTotal(subLastChild) ? classes.cellHeaderName : ""}
                                >
                                  {subLastChild.Name}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className={findTotal(subLastChild) ? classes.cellHeaderNumber : ""}
                                >
                                  {NumberFormat(subLastChild.Current ?? 0)}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className={findTotal(subLastChild) ? classes.cellHeaderNumber : ""}
                                >
                                  {NumberFormat(subLastChild.Prior ?? 0)}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className={findTotal(subLastChild) ? classes.cellHeaderNumber : ""}
                                >
                                  {NumberFormat(subLastChild.Varience ?? 0)}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className={findTotal(subLastChild) ? classes.cellHeaderNumber : ""}
                                >
                                  {NumberFormat(subLastChild.Percent ?? 0)}
                                </TableCell>
                              </TableRow>

                              {open[subLastChild.Name] &&
                                subLastChild.children &&
                                subLastChild.children.map((lastChild, lastChildIndex) => (
                                  <TableRow key={`lastChild${lastChildIndex}`} className={classes.TableRowSub}>
                                    <TableCell />
                                    <TableCell style={{ paddingLeft: 80 }}>{lastChild.Name}</TableCell>
                                    <TableCell align="right">{NumberFormat(lastChild.Current ?? 0)}</TableCell>
                                    <TableCell align="right">{NumberFormat(lastChild.Prior ?? 0)}</TableCell>
                                    <TableCell align="right">{NumberFormat(lastChild.Varience ?? 0)}</TableCell>
                                    <TableCell align="right">{NumberFormat(lastChild.Percent ?? 0)}</TableCell>
                                  </TableRow>
                                ))}
                            </>
                          ))}
                      </>
                    ))}
                </>
              ))}
          </React.Fragment>
        ));
      }

      return null;
    },
  };

  const CustomTableHead = (props) => (
    <>
      <TableHead className={classes.colorCell}>
        <TableRow>
          <TableCell colSpan={2}>
            {!statusOpen ? (
              <Button className={classes.btnColorCell} onClick={() => expandAll()}>
                <FaAngleDoubleDown />
                {"  "}
                Expand
              </Button>
            ) : (
              <Button className={classes.btnColorCell} onClick={() => collapseAll()}>
                <FaAngleDoubleRight />
                {"  "}
                Collapse
              </Button>
            )}
          </TableCell>

          <TableCell colSpan={2} align="center" className={classes.colorCell}>
            Year To Date
          </TableCell>

          <TableCell colSpan={2}></TableCell>
          {/* <TableCell colSpan={3} align="center" className={classes.colorCell}>
           
          </TableCell> */}
        </TableRow>
      </TableHead>
      <MuiTableHead {...props} />
    </>
  );

  return (
    <div>
      {dataTable && (
        <MUIDataTable
          title={
            <Typography variant="h6" style={{ fontSize: "1.1111111111111112rem" }}>
              {title}
            </Typography>
          }
          data={dataTable ?? []}
          columns={columns}
          options={options}
          components={{ TableHead: CustomTableHead }}
        />
      )}
    </div>
  );
};

export default ReportBackDrop(Table);
